import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
import { HERO_MOCKUP_URL } from "./utils/heroImage";
initMetaPixel();

// Preload the hero's LCP image as early as possible, before React even renders the <img>
// tag, so the browser can start fetching it immediately instead of discovering it deep
// inside the render tree.
const preloadLink = document.createElement("link");
preloadLink.rel = "preload";
preloadLink.as = "image";
preloadLink.href = HERO_MOCKUP_URL;
preloadLink.setAttribute("fetchpriority", "high");
document.head.appendChild(preloadLink);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-232" data-mp="2p1uzsrx3var6" />);
}